import Grid from '@mui/material/Grid';
import { ValidateDatePicker } from '../../Generic/Forms/ValidateDatePicker';
import { useState } from 'react';
import { useParams } from 'react-router';
import { Arrangement, Person } from '../../GeneratedClient';
import { usePersonLookup } from '../../Model/DirectoryModel';
import { useV1CasesModel } from '../../Model/V1CasesModel';
import { UpdateDialog } from '../../Generic/UpdateDialog';

interface StartArrangementDialogProps {
  v1CaseId: string;
  arrangement: Arrangement;
  onClose: () => void;
}

export function StartArrangementDialog({
  v1CaseId,
  arrangement,
  onClose,
}: StartArrangementDialogProps) {
  const familyIdMaybe = useParams<{ familyId: string }>();
  const familyId = familyIdMaybe.familyId as string;

  const v1CasesModel = useV1CasesModel();
  const personLookup = usePersonLookup();

  const person = personLookup(
    familyId,
    arrangement.partneringFamilyPersonId
  ) as Person;

  const [startedAtLocal, setStartedAtLocal] = useState(null as Date | null);

  const [dobError, setDobError] = useState(false);

  async function save() {
    // Enforce that this goes to the very start of the day (00:00:00.000 AM) for now.
    // In the future, this should be a date-only value.
    startedAtLocal?.setHours(0, 0, 0, 0);
    await v1CasesModel.startArrangement(
      familyId,
      v1CaseId,
      arrangement.id!,
      startedAtLocal!
    );
  }

  return (
    <UpdateDialog
      title={`Do you want to start this ${arrangement.arrangementType} arrangement for ${person.firstName} ${person.lastName}?`}
      onClose={onClose}
      onSave={save}
      enableSave={() => startedAtLocal !== null && !dobError}
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <ValidateDatePicker
            label="When was this arrangement started?"
            value={startedAtLocal}
            onChange={setStartedAtLocal}
            onErrorChange={setDobError}
            disableFuture
            textFieldProps={{
              fullWidth: true,
              required: true,
              sx: { marginTop: 1 },
            }}
          />
        </Grid>
      </Grid>
    </UpdateDialog>
  );
}
